import { useEffect } from 'react'
import MuiBox from '@mui/material/Box'
import { useFormik, Form, FormikProvider } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../../../components/formik-control'
import {
  useAddProducerMutation,
  useUpdateProducerMutation,
} from '../../../../clients/slice'

const ProducerForm = ({
  client,
  producer,
  onSubmitEvent,
  setSubmitEvent,
  setShowDrawer,
}) => {
  const [updateProducer] = useUpdateProducerMutation()
  const [addProducer] = useAddProducerMutation()

  const initialValues = {
    id: producer?.id ?? undefined,
    name: producer?.name ?? '',
    title: producer?.title ?? '',
    city: producer?.city ?? '',
    isActive: producer?.isActive ?? true,
  }

  const validationSchema = Yup.object({
    name: Yup.string().required('Required'),
  })

  const onSubmit = async (values) => {
    if (values.id)
      await updateProducer({ clientId: client.id, producer: values })
    else await addProducer({ clientId: client.id, producer: values })
    setSubmitEvent()
    setShowDrawer(false)
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  })

  useEffect(() => {
    if (onSubmitEvent) {
      formik.handleSubmit()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onSubmitEvent])

  return (
    <FormikProvider value={formik}>
      <Form>
        <MuiBox>
          <FormikControl
            control="input"
            label="Name"
            name="name"
            fullWidth
            margin="normal"
          />
        </MuiBox>
        <MuiBox>
          <FormikControl
            control="input"
            label="Title"
            name="title"
            fullWidth
            margin="normal"
          />
        </MuiBox>
        <MuiBox>
          <FormikControl
            control="input"
            label="City"
            name="city"
            fullWidth
            margin="normal"
          />
        </MuiBox>
        <MuiBox>
          <FormikControl
            control="checkbox"
            label="Active"
            name="isActive"
            margin="normal"
          />
        </MuiBox>
      </Form>
    </FormikProvider>
  )
}

export default ProducerForm
